import Vue from 'vue'
import Vuex from 'vuex'
import { tradeOrder } from '@/api/trade'
import {mainTop} from '@/api/main'
import { withdrawalList } from '@/api/withdraw'
import { withdrawStatus } from '@/api/withdraw'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    assetOrderId: '', // 查看订单id
    info: {}, // 一些信息
    homePageInfo: {}, // 首页展示的信息
    tradePageInfo: {}, // 交易管理
    assetPageInfo: {}, // 资产管理页信息
    assetStatus: {} // 状态信息
  },
  getters: {
    info (state) {
      return JSON.parse(localStorage.getItem('info'))
    },
    companyList (state) {
      const companyList = state.info.companyList || JSON.parse(localStorage.getItem('info')).companyList
      return companyList
    },
    chooseCompany (state) {
      const chooseCompany = state.info.chooseCompany || JSON.parse(localStorage.getItem('info')).chooseCompany
      return chooseCompany
    },
    mchId (state) {
      const mchId = state.info.companyId || JSON.parse(localStorage.getItem('info')).companyId
      return mchId
    },
    homeTopInfo (state) {
      let { account, count, sum } = state.homePageInfo
      return {
        account,
        count,
        sum
      }
    },
    echartLine (state) {
      let {countList, dayList} = state.homePageInfo
      return {
        lineData: countList,
        week: dayList
      }
    },
    echartBar (state) {
      let {dayList, sumList} = state.homePageInfo
      return {
        week: dayList,
        barData: sumList
      }
    },
    noticeMsg (state) {
      let footerData = state.homePageInfo.footerData || []
      return footerData
    },
    tradeCount (state) {
      return state.tradePageInfo.count
    },
    tradeTotal (state) {
      return state.tradePageInfo.total
    },
    tradeData (state) {
      return state.tradePageInfo.data
    },
    totalData (state) {
      return state.tradePageInfo
    },
    assetCount (state) {
      return state.assetPageInfo.count && state.assetPageInfo.count || 0
    },
    assetTotal (state) {
      return state.assetPageInfo.total && state.assetPageInfo.total || 0
    },
    assetData (state) {
      return state.assetPageInfo.data && state.assetPageInfo.data || []
    },
    getOrderId (state) {
      return state.assetOrderId || localStorage.getItem('a_orderId')
    }
  },
  mutations: {
    SET_INFO (state, payload) {
      if ((!payload.isLogin) && payload.deep) {
        localStorage.clear()
        state.info = {}
        return
      }
      let data = JSON.parse(localStorage.getItem('info')) || {}
      let companyList = (data && data.companyList) || payload.companyList
      data['chooseCompany'] = companyList[payload.companyIndex]
      data['companyId'] = companyList[payload.companyIndex].id
      Object.assign(data, payload)
      localStorage.setItem('info', JSON.stringify(data))
      state.info = data
    },
    SET_HOMEPAGE (state, payload) {
      state.homePageInfo = payload
    },
    SET_TRADE (state, payload) {
      state.tradePageInfo = payload
    },
    SET_ASSET (state, payload) {
      state.assetPageInfo = payload
    },
    SET_ORDER_ID (state, payload) {
      localStorage.setItem('a_orderId', payload)
      state.assetOrderId = payload
    },
    SET_STATUS (state, payload) {
      state.assetStatus = payload
    }
  },
  actions: {
    getHomepage ({commit, getters}) {
      // console.log('123')
      const { mchId } = getters
      mainTop(mchId).then(res => {
        let { data } = res
        commit('SET_HOMEPAGE', data)
      }).catch(error => {

      })
    },
    getTradeInfo ({commit}, data) {
      tradeOrder(data).then(res => {
        commit('SET_TRADE', res.data)
      })
    },
    getAssetInfo ({commit}, payload) {
      withdrawalList(payload).then(res => {
        commit('SET_ASSET', res.data)
      })
    },
    getStepInfo ({commit, getters}) {
      const id = getters.getOrderId
      withdrawStatus(id).then(
        res => {
          commit('SET_STATUS', res.data)
        }
      )
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js